import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import useGlobal from '@/composables/useGlobal'
import {
PROFILE_PAGE_NAME,
} from '@/components/pages/cabinet/routes'
import { isLp, isAdmin } from '@access/permissions'

import {
  reportDownloadResource,
  reportCsvDownloadResource,
} from '@/services/reports.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionMenu',
  props: ['element', 'forAll', 'isFile'],
  emits: ['action'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props
const emit = __emit
const { $t } = useGlobal()
const sidebar = ref(null)

const menuData = ref([
  {
    title: $t('Report'),
    id: 'report',
    icon: 'i-report',
    active: () => props?.forAll ? true : props?.element?.canReport,
    hidden: isAdmin
  },
  {
    title: $t('Undo'),
    id: 'undo',
    icon: 'i-undo',
    active: () => props?.element?.canUndo,
    hidden: isAdmin
  },
  {
    title: $t('Edit'),
    id: 'edit',
    icon: 'i-edit',
    active: () => props?.element?.canEdit,
    hidden: isLp
  },
  {
    title: $t('Report download PDF'),
    id: 'download',
    type: 'pdf',
    icon: 'i-download',
    hidden: !props?.isFile,
    active: () => props?.element?.reportId,
  },
  {
    title: $t('Report download CSV'),
    id: 'download',
    type: 'csv',
    icon: 'i-download',
    hidden: !props?.isFile,
    active: () => props?.element?.reportId,
  },
])

async function fileDownload(id, originalId, type) {
  const resource = {
    'csv': reportCsvDownloadResource,
    'pdf': reportDownloadResource
  }
  try {
    resource[type].execute({ id }).then((response) => {
      return response.blob()
    }).then((response) => {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(response)
      link.download = `${originalId}.${type}`
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link)

    })
  } catch (e) {
    return Promise.reject(e)
  }
}

function closeSidebar() {
  sidebar.value.classList.remove('is-open')
}
function toggleSidebar() {
  sidebar.value.classList.toggle('is-open')
}


const __returned__ = { props, emit, $t, sidebar, menuData, fileDownload, closeSidebar, toggleSidebar, ref, get useGlobal() { return useGlobal }, get PROFILE_PAGE_NAME() { return PROFILE_PAGE_NAME }, get isLp() { return isLp }, get isAdmin() { return isAdmin }, get reportDownloadResource() { return reportDownloadResource }, get reportCsvDownloadResource() { return reportCsvDownloadResource } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})